export default "__VITE_ASSET__DspKT$ZV__"